const callbackFunctions: VoidFunction[] = [];
let onloadFired = false;

/**
 * Use this function to attach callback function to window onload
 *
 * @export
 * @param {Function} callback
 */
const onWindowLoad = (callback: VoidFunction) => {
    if (onloadFired) {
        try {
            callback();
        } catch (e) {
            /** DO NOTHING */
        }
        return;
    }
    callbackFunctions.push(callback);
};

if (__BROWSER__) {
    window.onload = () => {
        callbackFunctions.map(callback => {
            try {
                callback();
            } catch (e) {
                /** DO NOTHING */
            }
        });

        onloadFired = true;
    };
}

export default onWindowLoad;
